// extracted by mini-css-extract-plugin
export default {"formWrapper":"styles_formWrapper__q6axI"};